import _ from 'underscore';

export const ShoppingCampaign = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Campaign',
    },
    Name: {
      'bulk-upload-header': 'Campaign',
    },
    CampaignSubType: {
      'bulk-upload-header': 'Sub Type',
    },
    TrackingUrlTemplate: {
      'bulk-upload-header': 'Tracking Template',
      bulkDeleteValueIfEmpty: true,
    },
    UrlCustomParameters: {
      'bulk-upload-header': 'Custom Parameter',
      'bulk-upload-mapper': function (value) {
        return _.map(value, p => `{_${p.Key}}=${p.Value}`).join('; ');
      },
      bulkDeleteValueIfEmpty: true,
    },
    FinalUrlSuffix: {
      'bulk-upload-header': 'Final Url Suffix',
      bulkDeleteValueIfEmpty: true,
    },
    BudgetId: {
      'bulk-upload-header': 'Budget Id',
    },
    BudgetName: {
      'bulk-upload-header': 'Budget Name',
    },
    TimeZone: {
      'bulk-upload-header': 'Time Zone',
    },
    AdScheduleUseSearcherTimeZone: {
      'bulk-upload-header': 'Ad Schedule Use Searcher Time Zone',
    },
    Languages: {
      filterable: true,
      'bulk-upload-header': 'Language',
      'bulk-upload-mapper': function (value) {
        return value.join(';');
      },
    },
    NativeBidAdjustment: {
      'bulk-upload-header': 'Bid Adjustment',
    },
    CampaignType: {
      'bulk-upload-header': 'Campaign Type',
      'bulk-upload-mapper': function (value) {
        if (value === 'DynamicSearchAds') {
          return 'Dynamic Search';
        }
        return value;
      },
    },
    DomainName: {
      'bulk-upload-header': 'Website',
    },
    LanguageCode: {
      'bulk-upload-header': 'Domain Language',
    },
    Source: {
      'bulk-upload-header': 'Source',
    },
    CashbackMonthlyBudget: {
      'bulk-upload-header': 'Cashback Monthly Budget',
    },
    CashbackPercent: {
      'bulk-upload-header': 'Cashback Percent',
    },
    CashbackScope: {
      'bulk-upload-header': 'Cashback Scope',
    },
    PersonalizedOffersEnabled: {
      'bulk-upload-header': 'Personalized Offers Enabled',
    },
    CouponsEnabled: {
      'bulk-upload-header': 'Personalized Coupons Enabled',
    },
    TargetSetting: {
      'bulk-upload-header': 'Target Setting',
    },
    DisclaimerAdsEnabled: {
      'bulk-upload-header': 'Disclaimer Ads Enabled',
    },
    FeedLabel: {
      'bulk-upload-header': 'FeedLabel',
    },
    SalesCountry: {
      'bulk-upload-header': 'Country Code',
    },
    ShoppableAdsEnabled: {
      'bulk-upload-header': 'Shoppable Ads Enabled',
      'bulk-upload-mapper': function (value) {
        return value ? 'true' : 'false';
      },
    },
    BrandOnly: {
      'bulk-upload-header': 'Brand Only',
      'bulk-upload-mapper': function (value) {
        return value ? 'true' : 'false';
      },
    },
    LocalInventoryAdsEnabled: {
      'bulk-upload-header': 'Local Inventory Ads Enabled',
      'bulk-upload-mapper': function (value) {
        return value ? 'true' : 'false';
      },
    },
    Priority: {
      'bulk-upload-mapper': function (value) {
        const mapping = {
          Low: 0,
          Medium: 1,
          High: 2,
          Highest: 3,
        };

        return mapping[value];
      },
    },
    ProviderId: {
      'bulk-upload-header': 'Store Id',
    },
    FeedId: {
      'bulk-upload-header': 'Feed Id',
    },
    VerifiedTrackingData: {
      'bulk-upload-header': 'Verified Tracking Setting',
    },
    IsPromotionsForBrands: {
      'bulk-upload-header': 'Is Promotions For Brands',
    },
    AutoGeneratedImageOptOut: {
      'bulk-upload-header': 'Auto Generated Image Assets Opt Out',
      type: 'boolean',
    },
    AutoGeneratedTextOptOut: {
      'bulk-upload-header': 'Auto Generated Text Assets Opt Out',
      type: 'boolean',
    },
    FinalUrlExpansionOptOut: {
      'bulk-upload-header': 'Url Expansion Opt Out',
      type: 'boolean',
    },
    TermExclusions: {
      'bulk-upload-header': 'Term Exclusions',
      'bulk-upload-mapper': function (value) {
        if (value === undefined) return '';
        if (_.isArray(value) && value.length > 0) {
          return JSON.stringify(value.map(item => (typeof item === 'string' ? { Text: item } : item)));
        }
        return 'delete_value';
      },
    },
    MessagingRestrictions: {
      'bulk-upload-header': 'Messaging Restrictions',
      'bulk-upload-mapper': function (value) {
        if (value === undefined) return '';
        if (_.isArray(value) && value.length > 0) {
          return JSON.stringify(value.map(item => (typeof item === 'string' ? { Text: item } : item)));
        }
        return 'delete_value';
      },
    },
    CostPerSaleOptOut: {
      'bulk-upload-header': 'Cost Per Sale Opt Out',
      type: 'boolean',
    },
    AppStore: {
      'bulk-upload-header': 'App Store',
      type: 'string',
    },
    AppId: {
      'bulk-upload-header': 'App Id',
      type: 'string',
    },
    IsBSREnabled: {
      'bulk-upload-header': 'Is BSR Enabled',
      type: 'boolean',
    },
    BSRAdDistribution: {
      'bulk-upload-header': 'BSR Ad Distribution',
      type: 'string',
    },
    NetworkDistribution: {
      'bulk-upload-header': 'Network Distribution',
      type: 'string',
    },
    ProductAdsOptOut: {
      'bulk-upload-header': 'Product Ads Brand Exclusion Opt Out',
      type: 'boolean',
    },
    BrandColor: {
      'bulk-upload-header': 'Brand Color',
      type: 'string',
      'bulk-upload-mapper': function (colors) {
        if (_.isArray(colors)) {
          return _.isEmpty(colors) ? 'delete_value' : JSON.stringify(colors.map(color => ({
            text: color.Asset.Text,
          })));
        }
        return '';
      },
    },
    PageFeedIds: {
      type: 'string',
      'bulk-upload-header': 'Page Feed Ids',
      'bulk-upload-mapper': function (value) {
        if (_.isArray(value)) {
          return _.isEmpty(value) ? 'delete_value' : value.join(';');
        }
        return '';
      },
    },
    NewCustomerAcquisitionGoalId: {
      'bulk-upload-header': 'New Customer Acquisition Goal Id',
    },
    NewCustomerAcquisitionBidOnlyMode: {
      'bulk-upload-header': 'New Customer Acquisition Bid Only Mode',
      type: 'boolean',
    },
    AdditionalConversionValue: {
      'bulk-upload-header': 'Additional Conversion Value',
    },
  },
};
